module.exports = __webpack_public_path__ + "static/media/haircare_female.1ea6ff92.svg";